import { Box, Flex, Text } from "@chakra-ui/react";
import Image from "next/image";
import { IconBookmark, IconBookmarkFilled } from "../../styles/icons";
import { useRouter } from "next/router";

const ArticleRecommendedTherapist = ({
  image,
  title,
  name,
  slug,
  onBookmarkClick,
  isBookmarked = false,
}) => {
  const router = useRouter();
  const handleBookmarkClick = (e) => {
    e.stopPropagation();
    onBookmarkClick();
  };

  const navToTherapist = () => {
    router.push(`/counsellors/${slug}`);
  };

  return (
    <Flex
      w="100%"
      justify="space-between"
      align="flex-start"
      borderWidth="0.5px"
      borderColor="brand.200"
      borderRadius="20px"
      py="12px"
      px="20px"
      maxH="88px"
      onClick={navToTherapist}
    >
      {image && (
        <Box
          width={{ base: "64px" }}
          height={{ base: "64px" }}
          borderRadius="50%"
          overflow="hidden"
          position="relative"
          minW="64px"
        >
          <Image
            alt="practitioner photo"
            objectFit="cover"
            layout="fill"
            src={image}
            placeholder="blur"
            blurDataURL="data:image/jpeg;base64,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"
          />
        </Box>
      )}

      <Flex direction="column" ml="12px" flex={1}>
        <Text textStyle="h5bold">{name}</Text>
        <Text textStyle="h6" color="brand.200">
          {title}
        </Text>
      </Flex>
      <Flex
        borderRadius="100%"
        borderColor="brand.400"
        borderWidth="1px"
        w="40px"
        h="40px"
        minW="40px"
        justify="center"
        align="center"
        cursor="pointer"
        onClick={handleBookmarkClick}
      >
        {isBookmarked ? (
          <IconBookmarkFilled color="#587500" />
        ) : (
          <IconBookmark color="#587500" />
        )}
      </Flex>
    </Flex>
  );
};

export default ArticleRecommendedTherapist;
